module.exports = __webpack_public_path__ + "static/media/area2.3e855908.png";